import { LOCAL_USER_UPDATED_EVENT, removeCookie, setCookie } from "@jti/fe-common";
import BrowserStorage from "./BrowserStorage";
import { calculateExpireDate } from "./calculateExpireDate";
export class User {
    constructor(browserStorage) {
        this.browserStorage = browserStorage;
    }
    getDefaultUser() {
        return {
            consent_renewal_required: false,
            is_age_verified: false,
            is_device_registered: false,
            unique_id: -1,
            first_name: "",
            last_name: "",
            email: "",
            ciam_token: "",
            magento_token: "",
            session_token: "",
        };
    }
    getUser() {
        return Object.assign(Object.assign({}, this.getDefaultUser()), this.browserStorage.get("user", {}));
    }
    setUser(values) {
        setCookie("isUserLoggedIn", true, "/", calculateExpireDate(7).toUTCString());
        const user = this.getUser();
        this.browserStorage.set("user", Object.assign(Object.assign(Object.assign({}, this.getDefaultUser()), user), values));
    }
    clearUser() {
        removeCookie("isUserLoggedIn", "/");
        this.browserStorage.set("user", null);
    }
}
export const setUsersDeviceStatus = (hasDevices) => {
    const browserStorage = new BrowserStorage();
    const user = getUser();
    browserStorage.set("user", Object.assign(Object.assign({}, user), { has_registered_device: hasDevices }));
    window.dispatchEvent(new Event(LOCAL_USER_UPDATED_EVENT));
};
export const getUser = () => {
    const session = new User(new BrowserStorage());
    return session.getUser();
};
export default User;
//# sourceMappingURL=User.js.map